import { Archive, CircleCheck, Pause } from "lucide-react";

import type { ClientStatus } from "@/api/types";
import { Badge } from "@/components/ui/badge";

/** Per-client engagement status — informational, doesn't gate API access. */
export function ClientStatusBadge({ status }: { status: ClientStatus }) {
	switch (status) {
		case "active":
			return (
				<Badge variant="success">
					<CircleCheck className="mr-1 h-3 w-3" aria-hidden />
					Active
				</Badge>
			);
		case "paused":
			return (
				<Badge variant="outline">
					<Pause className="mr-1 h-3 w-3" aria-hidden />
					Paused
				</Badge>
			);
		case "archived":
			return (
				<Badge variant="outline" className="text-muted-foreground">
					<Archive className="mr-1 h-3 w-3" aria-hidden />
					Archived
				</Badge>
			);
	}
}
